import { render } from "./ResultDialog.vue?vue&type=template&id=65c95c04"
import script from "./ResultDialog.vue?vue&type=script&lang=js"
export * from "./ResultDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__